import React from 'react';

import { ShopFocusHeader } from 'shared/components';
import { ShopFocusHeaderProps } from '../ShopFocusHeader';
import useOnInternalOnlyBack from './useOnInternalOnlyBack';

/* The WebViewFocusHeader overrides the DefaultFocusHeader onBack prop to only allow backs within the Next app
 * (can't go back in history before visiting the app).
 */

export default function WebViewFocusHeader(
  props: Partial<ShopFocusHeaderProps>,
) {
  const onBack = useOnInternalOnlyBack();
  return <ShopFocusHeader onBack={onBack} {...props} />;
}
